import React, { useMemo } from 'react';
import styled from 'styled-components';
import { sanitizeHtml } from '../utils/sanitizeHtml';

interface Props {
  children?: string;
}

const FormDescription: React.FC<React.PropsWithChildren<Props>> = ({ children }) => {
  const sanitized = useMemo(() => (children ? sanitizeHtml(children) : ''), [children]);

  if (!children) {
    return null;
  }
  // biome-ignore lint/security/noDangerouslySetInnerHtml: HTML is sanitized via sanitizeHtml allowlist above
  return <StyledDescription dangerouslySetInnerHTML={{ __html: sanitized }} />;
};

export default FormDescription;

const StyledDescription = styled.div`
  margin: 0 0 32px 0;
  font-size: 14px;
  img {
    display: block;
    margin: 0 auto 32px auto;
  }
`;
